
















import Vue from "vue";
import { authGuard } from "../router/guards";

export default Vue.extend({
  name: "MyTeamsPage",
  beforeRouteEnter: authGuard
});
